module.exports = __webpack_public_path__ + "img/ai_teacher_Anaya.000fd3f2.png";